import React, { cloneElement } from 'react';
import clsx from 'clsx';
import { getValidChildren } from '../utils/index.js';
export const AvatarGroup = ({ size, moreCount, children, }) => {
    const validChildren = getValidChildren(children);
    const reversedChildren = validChildren.reverse();
    const clones = reversedChildren.map(child => {
        const childProps = {
            className: 'ring-2 ring-surface ring-offset-surface',
            size,
        };
        return cloneElement(child, childProps);
    });
    if (moreCount) {
        clones.push(React.createElement(MoreIndicator, { moreCount: moreCount, size: size }));
    }
    const sizeClsx = {
        '-space-s-1': size === 'sm' || size === 'xs',
        '-space-s-2 ': size === 'md',
        '-space-s-2': size === 'lg' || size === 'xl',
    };
    return React.createElement("div", { className: clsx('flex overflow-hidden', sizeClsx) }, clones);
};
const MoreIndicator = ({ moreCount, size }) => {
    const sizeClsx = {
        'h-6 w-6 ': size === 'xs',
        'h-8 w-8': size === 'sm',
        'h-10 w-10': size === 'md',
        ' h-12 w-12': size === 'lg',
        'h-16 w-16': size === 'xl',
        'h-24 w-24': size === '2xl',
        'h-32 w-32': size === '3xl',
    };
    return (React.createElement("span", { className: "inline-block relative" },
        React.createElement("span", { className: clsx('inline-flex items-center justify-center rounded-full ring-2 ring-surface ring-offset-surface', 'bg-surface-subdued', sizeClsx) },
            React.createElement("span", { className: `text-${size} font-medium leading-none text-content-subdued` },
                "+",
                moreCount))));
};
//# sourceMappingURL=AvatarGroup.js.map